import _ from 'lodash'

export const getTypeOfComponent = (elem) => {
  if (!elem) {
    return ''
  }
  if (elem.getIn(['type'], '') === 'Modal' && elem.getIn(['props', 'isExp'])) {
    return 'Responsive Modal'
  }
  if (elem.getIn(['type'], '') === 'FormField') {
    return elem.getIn(['props', 'control'], elem.getIn(['type'], ''))
  }
  if (elem.getIn(['type'], '') === 'FormField') {
    return elem.getIn(['props', 'control'], elem.getIn(['type'], ''))
  } else if (elem.getIn(['type'], '') === 'Widget') {
    if (elem.getIn(['props', 'data', 'Type']) == 'chart') {
      return elem.getIn(['props', 'data', 'Props', 'ChartType'])
    } else {
      return elem.getIn(['props', 'data', 'Type'], elem.getIn(['type'], ''))
    }
  }

  return elem.getIn(['type'], '')
}

export const getDisplayType = (type, isSelectedArea, isHTML = false, isSettingsLabel = false) => {
  if (type === 'DiffViewer') {
    return 'Text Comparison'
  } else if (type === 'TextReview') {
    return 'Text Review'
  } else if (type === 'SmartVOtpForm') {
    return 'SmartV OTP Form'
  } else if (type === 'custom##custom') {
    return 'Custom Icon'
  } else if (type == 'ellipsysModal') {
    return 'Ellipsys Modal'
  } else if (type == 'textarea') {
    return 'TextArea'
  } else if (type == 'daterange') {
    return isSettingsLabel ? 'Date Range Field' : 'Date Range'
  } else if (type == 'richtextarea') {
    return 'Rich TextArea'
  } else if (type == 'datetime') {
    return 'DateTime'
  } else if (type == 'StarRating') {
    return 'Star Rating'
  } else if (type == 'SurveyList') {
    return 'Survey List'
  } else if (type == 'ImageChoice') {
    return 'Image Choice'
  } else if (type == 'fileupload') {
    return 'File Upload'
  } else if (type == 'buttongroup') {
    return 'Button Group'
  } else if (type == 'url') {
    return 'URL'
  } else if (type == 'Badge') {
    return 'Badge Counter'
  } else if (isSelectedArea && type == 'Strip') {
    return 'Strip column'
  } else if (type == 'Scroll') {
    return 'Scroll Container'
  } else if (type == 'Stack') {
    return 'Auto Fit Container'
  } else if (type == 'stackSide') {
    return 'Stacked Side'
  } else if (type == 'stackLine') {
    return 'Stacked Line Chart'
  } else if (type == 'Section') {
    return 'Container'
  } else if (type == 'select') {
    return 'DropDown'
  } else if (type == 'richtextarea') {
    return 'Rich Textarea'
  } else if (type == 'multiSelect') {
    return 'Multi Select Picklist'
  } else if (type == 'Svg') {
    return 'Shape'
  } else if (type == 'DateRange') {
    return 'Date Range'
  } else if (type == 'switch') {
    return 'Switcher'
  }
  const str = String(type)
    .replace(/^(webnotify)$/, 'Push Notify')
    .replace(/^(VerticalCard)$/, 'Comparison Cards')
    .replace(/^(TextCounter)$/, 'Quantity Counter')
    .replace(/^(redirectModal)$/, 'Redirect Modal')
    .replace(/^(IntDocGen)$/, 'Interactive DocGen')
    .replace(/^(DrawerEl)$/, 'Custom Drawer')
    .replace(/^(list)$/, 'List')
    .replace(/^(infoModal)$/i, 'Information Modal')
    .replace(/^(warningModal)$/i, 'Warning Modal')
    .replace(/^(confirmMsg)$/i, 'Confirm Modal')
    .replace(/^sProfile$/i, 'Profile')
    .replace(/^sMTypes$/i, 'Meeting Types')
    .replace(/^sCalendar$/i, 'Calendar')
    .replace(/^sTime$/i, 'Time')
    .replace(/^sForm$/i, 'Form')
    .replace(/^sOk$/i, 'Confirmation')
    .replace(/^(PageSurvey)$/i, 'Web Survey')
    .replace(/^(Rating)$/i, 'Rating Scale')
    .replace(/^(ContinualForm)$/i, 'Continual Form')
    .replace(/^(MultiStepper)$/i, 'Multi Step')
    .replace(/^(eComSlide)$/i, 'ECommerce Product Slides')
    .replace(/^(eComCheck)$/i, 'ECommerce Checkout Page')
    .replace(/^(eComPaymentDlg)$/i, 'ECommerce Payment Dialog')
    .replace(/^(eComRelProd)$/i, 'ECommerce Related Products')
    .replace(/^(eProdDlg)$/i, 'ECommerce Product Dialog')
    .replace(/^(eSumPanel)$/i, 'ECommerce Summary Panel')
    .replace(/^(eComCartPage)$/i, 'ECommerce Cart Full Page')
    .replace(/^(SmartVLoginForm)$/i, 'Log In Form')
    .replace(/^(undefined)$/i, '')
    .replace(/^(eComCat)$/i, 'ECommerce Catalogue')
    .replace(/^(e_catalog)$/i, 'ECommerce Catalogue')
    .replace(/^(eComProd)$/i, 'ECommerce Product')
    .replace(/^(ECommerceCatalogue)$/i, 'ECommerce Catalogue')
    .replace(/^(ECommerceProduct)$/i, 'ECommerce Product')
    .replace(/^(e_product)$/i, 'ECommerce Product')
    .replace(/^(EComCatCtrl)$/i, 'ECommerce Catalogue Element')
    .replace(/^(EComProdCtrl)$/i, 'ECommerce Product Element')
    .replace(/^(ECommerceCartIcon)$/i, 'ECommerce Cart Icon')
    .replace(/^(ECommerceCategories)$/i, 'ECommerce Categories')
    .replace(/^(EComBadge)$/i, 'ECommerce Cart Icon')
    .replace(/^(UserTip)$/i, 'User Tip')
    .replace(/^(SmartVVerfField)$/i, 'Verification Fields')
    .replace(/^(SmartVLoginField)$/i, 'Log In Fields')
    .replace(/^(SmartVRegField)$/i, 'Registration Fields')
    .replace(/^(SmartVProfileField)$/i, 'Profile Fields')
    .replace(/^(Link_a)$/i, 'Link')
    .replace(/^(Typography)$/i, `Text${isHTML ? ' (HTML)' : ''}`)
    .replace(/^(FormField)$/i, 'Input Fields')
    .replace(/^(confirmModal)$/i, 'Confirmation Modal')
    .replace(/^(formsuccessMsg)$/i, 'Form Success Modal')
    .replace(/^(sfNotificationMsg)$/i, 'Salesforce Messages')
    .replace(/^(sfPreloaderMsg)$/i, 'Salesforce Preloader')
    .replace(/^(lookupModal)$/i, 'Lookup Modal')
    .replace(/^(formerrorMsg)$/i, 'Form Error Modal')
    .replace(/^(Svg)$/i, 'Shape')
    .replace(/^(SmartVProfilePage)$/i, 'Profile')
    .replace(/^(SmartVLoginPage)$/i, 'Log In')
    .replace(/^(SmartVSignUpPage)$/i, 'Registration')
    .replace(/^(SmartVVerificationPage)$/i, 'Verification')
    .replace(/^(title)$/i, `Title${isHTML ? ' (HTML)' : ''}`)
    .replace(/^(h1)$/i, `Heading${isHTML ? ' (HTML)' : ''}`)
    .replace(/^(subhead)$/i, `Subhead${isHTML ? ' (HTML)' : ''}`)
    .replace(/^(p)$/i, `Paragraph${isHTML ? ' (HTML)' : ''}`)
    .replace(/^(form)$/i, 'Form')
    .replace(/^(table)$/i, 'Table')
    .replace(/^(caption)$/i, `Caption${isHTML ? ' (HTML)' : ''}`)
    .replace(/^(pie)$/i, 'Pie Chart')
    .replace(/^(doughnut)$/i, 'Doughnut Chart')
    .replace(/^(bar)$/i, 'Bar Chart')
    .replace(/^(line)$/, 'Line Chart')
    .replace(/^(bubble)$/i, 'Bubble Chart')
    .replace(/^(scatter)$/i, 'Scatter Chart')
    .replace(/^(horizontalBar)$/i, 'Horizontal Bar Chart')
  return _.map(String(str).split(' '), _.startCase).join(' ')
}
